export default __webpack_public_path__ + "static/media/icon_policy_overview_step1-3.178eb789.svg";